import { getUserState } from '../../main/selectors';
import type { GlobalState } from '../../../main/types/redux';
import type { UserDetailsState } from '../types';

export const getUserDetailsState = (state: GlobalState): UserDetailsState =>
  getUserState(state).details;
